let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("b6l47"), load("hDCAz"), load("ct3kN"), load("faXeM")]).then(() => parcelRequire('antvm'));